import { render, staticRenderFns } from "./upgrade-to-premium-button.vue?vue&type=template&id=581679c8&scoped=true"
import script from "./upgrade-to-premium-button.vue?vue&type=script&lang=js"
export * from "./upgrade-to-premium-button.vue?vue&type=script&lang=js"
import style0 from "./upgrade-to-premium-button.vue?vue&type=style&index=0&id=581679c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581679c8",
  null
  
)

export default component.exports